import script from "./ResolutionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResolutionTable.vue?vue&type=script&setup=true&lang=js"

import "./ResolutionTable.vue?vue&type=style&index=0&id=50d91cfa&lang=css"

const __exports__ = script;

export default __exports__